// 我的车辆列表数据
export const  columns=[
    {
        title:'序号',
        type:'index'
    },
     {
        title:'基地',
        dataIndex:"companyName",
        key:"companyName",
    },
    {
        title:'船号',
        dataIndex:"shipNum",
        key:"shipNum",
    },
    {
        title:'船名',
        dataIndex:"shipName",
        key:"shipName"
    },
    {
        title:'船舶类型',
        dataIndex:"shipType",
        key:"shipType"
    },
    {
        title:'船舶所属公司',
        dataIndex:"belongCompany",
        key:"belongCompany",
        width:120
    },
    
    {
        title:'承运商名称',
        dataIndex:"carrierName",
        key:"carrierName"
    },{
        title:'承运商代码',
        dataIndex:"carrierCode",
        key:"carrierCode"
    },
    {
        title:'船宽',
        dataIndex:"shipWide",
        key:"shipWide"
    },
    {
      title:'船长',
      dataIndex:"shipLength",
      key:"shipLength"
    },
    {
        title:'船高',
        dataIndex:"shipHigh",
        key:"shipHigh"
    },
    {
        title:'核定载重量',
        dataIndex:"loadWeight",
        key:"loadWeight"
    },
    {
        title:'适合装载品种',
        dataIndex:"loadType",
        key:"loadType",
        width:120

    }, 
    {
        title:'适航证书有效期至',
        dataIndex:"airworthinessTime",
        key:"airworthinessTime",
        width:180

    },
    {
        title:'适合装载证书有效期至',
        dataIndex:"loadLicenseTime",
        key:"loadLicenseTime",
        width:200

    }, 
    {
        title:'创建日期',
        dataIndex:"createTime",
        key:"createTime"
    },
    {
        title:'更新日期',
        dataIndex:"updateTime",
        key:"updateTime",
    },
    {
        title: "操作",
        slots:'actions',
        width:150,
        fixed:'right'
    }
]
/**
 * 传入对象与key值，返回当前名字
 * @param {*} obj array 类型数组
 * @param {*} key key 需要变化的key值
 */
export const changeKeyToName = (obj, key) => {
  let name = ''
  obj.map(item => {
      if (item.key == key) {
          name = item.name
      }
  })
  return name
}